import { supermarkets } from "@/mocks/supermarkets";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function Supermarkets() {
  return (
    <section id="onde-encontrar" className="relative w-full py-20 md:py-28 bg-organic-cool overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Pontos de Venda
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Onde Encontrar a{" "}
            <span className="text-primary-600">Big Mania</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base md:text-lg">
            Nossos produtos estão presentes nas principais redes de supermercados de Fortaleza. Encontre a Big Mania mais perto de você e leve praticidade e sabor para o seu dia a dia.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1} staggerChildren staggerDelay={0.1}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
            {supermarkets.map((market, idx) => (
              <div
                key={idx}
                className="group relative rounded-2xl overflow-hidden h-56 sm:h-64 img-zoom cursor-pointer"
              >
                <img
                  src={market.image}
                  alt={market.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-base font-heading font-semibold text-background-50">
                    {market.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.2}>
          <div className="text-center">
            <p className="text-foreground-700 text-base md:text-lg mb-2">
              Não encontrou um ponto de venda próximo?
            </p>
            <p className="text-foreground-600 text-sm md:text-base mb-6 max-w-xl mx-auto">
              Entre em contato conosco e descubra onde encontrar os produtos Big Mania ou solicite atendimento para sua empresa, evento ou estabelecimento.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://wa.me/558534942701?text=Olá! Gostaria de encontrar um ponto de venda próximo."
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-line text-lg"></i>
                Encontrar um ponto de venda
              </a>
              <a
                href="https://wa.me/558534942701"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                Falar pelo WhatsApp
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}